import React from "react";
import Component from "../../component/CustomerDetails";
const Dashboard = ({ title }) => {
    return (
        <>
            <Component />
        </>
    )
}
export default Dashboard;